import React from "react";

export default function Phonetic(props) {
  return (
    <div className="Phonetic">
      <p>{props.phonetic.text}</p>
    </div>
  );
}
